import { createContext, useContext, useEffect, useState } from 'react';
import api from '../utils/api';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const controller = new AbortController();
    const fetchUser = async () => {
      try {
        const res = await api.get('/auth/profile', {
          headers: { Authorization: `Bearer ${token}` },
          signal: controller.signal,
        });
        setUser(res.data);
      } catch (err) {
        if (err?.code === 'ERR_CANCELED' || err?.name === 'AbortError') return;
        console.error("Auth error", err);
        localStorage.removeItem('token');
        setUser(null);
      }
    };

    fetchUser();
    return () => controller.abort();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
